'use client'

import { FocusTrap } from 'focus-trap-react'

import { useNotificationContainer } from '@maestro/commerce-blocks/components/notification/batons/use-notification-container'
import NotificationToast from '@maestro/commerce-blocks/components/notification/notification-toast'

import '@maestro/commerce-blocks/components/notification/styles/notification.scss'

const NotificationContainer = () => {
  const {
    toasts,
    horizontal,
    vertical,
    toastContainerRef,
    removeToast,
    hasToasts,
  } = useNotificationContainer()

  if (!hasToasts) {
    return null
  }

  return (
    <FocusTrap
      active={hasToasts}
      focusTrapOptions={{
        clickOutsideDeactivates: true,
        escapeDeactivates: false,
      }}
    >
      <div
        className={`toasts__container toasts__container--${vertical} toasts__container--${horizontal}`}
        ref={toastContainerRef}
        tabIndex={-1}
      >
        {toasts.map((toast) => (
          <NotificationToast
            key={toast.id}
            id={toast.id}
            title={toast.title}
            description={toast.description}
            announceMessage={toast.announceMessage}
            type={toast.type}
            showClose={toast.showClose}
            onClose={() => removeToast(toast.id)}
            content={toast.content}
            isRemoved={toast.removed}
          />
        ))}
      </div>
    </FocusTrap>
  )
}

export default NotificationContainer
